import { $, bindClick } from "../lib/dom.js";
import { escHtml } from "../lib/hints.js";
import { api } from "../api.js";

let currentShopCode = "";
/** @type {{ merchant: object[]; templates: object[] } | null} */
let chartOptionsCache = null;

function notify(text, ok) {
  const el = $("key-banner");
  if (!el) return;
  el.textContent = text;
  el.classList.toggle("hidden", !text);
  el.classList.toggle("ok", !!ok);
}

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const rd = new FileReader();
    rd.onload = () => {
      const raw = String(rd.result || "");
      resolve(raw.split(",", 2)[1] || "");
    };
    rd.onerror = reject;
    rd.readAsDataURL(file);
  });
}

function productDetailPath(numIid) {
  const id = String(numIid || "").trim();
  if (!id) return "";
  const base = `/pages/mall/detail?num_iid=${encodeURIComponent(id)}`;
  if (currentShopCode) {
    return `${base}&shop_code=${encodeURIComponent(currentShopCode)}`;
  }
  return base;
}

function chartOptionHtml(selectedId) {
  const sel = String(selectedId || "").trim();
  const opts = [];
  const pushGroup = (label, charts) => {
    (charts || []).forEach((c) => {
      const id = c.chart_id || c.id || "";
      if (!id) return;
      const name = c.name || c.title || id;
      const picked = id === sel ? " selected" : "";
      opts.push(
        `<option value="${escHtml(id)}"${picked}>${escHtml(label)} · ${escHtml(name)}</option>`
      );
    });
  };
  if (chartOptionsCache) {
    pushGroup("本商家", chartOptionsCache.merchant);
  }
  const head = sel
    ? ""
    : '<option value="">请选择尺码表</option>';
  return head + (opts.length ? opts.join("") : '<option value="">暂无尺码表</option>');
}

function selectedCatCode() {
  return (($("mall-catalog-cat") && $("mall-catalog-cat").value) || "").trim();
}

async function loadSizeChartOptions() {
  const cat = selectedCatCode();
  const sel = $("mall-catalog-chart");
  if (!sel) return;
  if (!cat) {
    chartOptionsCache = null;
    sel.innerHTML = '<option value="">请先选择类目</option>';
    return;
  }
  sel.innerHTML = '<option value="">加载中…</option>';
  const { ok, data } = await api(
    "GET",
    `/api/v1/drama/garments/size-chart-options?cat_code=${encodeURIComponent(cat)}`
  );
  if (!ok || !data) {
    chartOptionsCache = null;
    sel.innerHTML = '<option value="">暂无尺码表</option>';
    return;
  }
  chartOptionsCache = {
    merchant: data.merchant || [],
    templates: data.templates || [],
  };
  sel.innerHTML = chartOptionHtml("");
}

function renderCatalogList(products) {
  const box = $("mall-catalog-list");
  if (!box) return;
  if (!products || !products.length) {
    box.innerHTML = "<p class='mc-desc'>尚无商品，请上方登记第一款。</p>";
    return;
  }
  const rows = products
    .map((p) => {
      const status = p.binding_status || "active";
      const path = productDetailPath(p.num_iid);
      const skcCount = (p.skcs || []).length;
      const chartId = String(p.size_chart_id || "").trim();
      const chartLabel = chartId
        ? `<code class="mc-catalog-chart-id">${escHtml(chartId)}</code>`
        : '<span class="mc-catalog-chart-missing">待绑定</span>';
      const pid = escHtml(p.product_id || p.num_iid || "");
      return `<tr data-product-id="${pid}">
        <td>${escHtml(p.title || p.num_iid || "—")}</td>
        <td><code>${escHtml(p.num_iid || "")}</code></td>
        <td>${skcCount}</td>
        <td>${escHtml(status)}</td>
        <td class="mc-catalog-chart-cell">${chartLabel}</td>
        <td class="mc-catalog-bind-cell">
          <select class="mc-catalog-row-chart" data-product-id="${pid}" aria-label="选择尺码表">
            ${chartOptionHtml(chartId)}
          </select>
          <button type="button" class="secondary mc-catalog-bind-save" data-product-id="${pid}">保存绑定</button>
        </td>
        <td class="mc-catalog-actions">
          ${path ? `<button type="button" class="secondary" data-copy-path="${escHtml(path)}">复制商品路径</button>` : ""}
        </td>
      </tr>`;
    })
    .join("");
  box.innerHTML = `<table class="mc-catalog-table">
    <thead><tr>
      <th>名称</th><th>num_iid</th><th>SKC</th><th>状态</th><th>当前尺码表</th><th>绑定/更换</th><th></th>
    </tr></thead>
    <tbody>${rows}</tbody>
  </table>`;
  box.querySelectorAll("[data-copy-path]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const text = btn.getAttribute("data-copy-path") || "";
      try {
        await navigator.clipboard.writeText(text);
        notify("已复制商品路径", true);
      } catch (_) {
        notify("复制失败，请手动选择", false);
      }
    });
  });
  box.querySelectorAll(".mc-catalog-bind-save").forEach((btn) => {
    btn.addEventListener("click", () => saveProductSizeChart(btn));
  });
}

async function saveProductSizeChart(btn) {
  const productId = btn.getAttribute("data-product-id") || "";
  const row = btn.closest("tr");
  const sel = row && row.querySelector(".mc-catalog-row-chart");
  const chartId = (sel && sel.value) || "";
  if (!productId) {
    notify("缺少商品 ID", false);
    return;
  }
  if (!chartId) {
    notify("请选择尺码表", false);
    return;
  }
  btn.disabled = true;
  const { ok, data } = await api(
    "PUT",
    `/api/v1/drama/garments/spu/${encodeURIComponent(productId)}`,
    { body: { size_chart_id: chartId } }
  );
  btn.disabled = false;
  if (!ok) {
    notify((data && data.message) || "绑定失败", false);
    return;
  }
  const bound = (data && data.size_chart_id) || chartId;
  notify(`已绑定尺码表：${bound}`, true);
  const cell = row && row.querySelector(".mc-catalog-chart-cell");
  if (cell) {
    cell.innerHTML = `<code class="mc-catalog-chart-id">${escHtml(bound)}</code>`;
  }
  if (sel) sel.value = bound;
}

export async function loadMallCatalog() {
  const { ok: shopOk, data: shop } = await api("GET", "/api/v1/fitting/mall/shop");
  if (shopOk && shop) {
    currentShopCode = String(shop.shop_code || "").trim();
  }
  await loadSizeChartOptions();
  const { ok, data } = await api("GET", "/api/v1/drama/garments/picker?include_offline=true");
  if (!ok) {
    const box = $("mall-catalog-list");
    if (box) box.textContent = "货架加载失败";
    return;
  }
  renderCatalogList((data && data.products) || []);
}

async function registerCatalogProduct() {
  const title = ($("mall-catalog-title") && $("mall-catalog-title").value || "").trim();
  const chartId = ($("mall-catalog-chart") && $("mall-catalog-chart").value || "").trim();
  const catCode = selectedCatCode();
  const picInput = $("mall-catalog-pic");
  const file = picInput && picInput.files && picInput.files[0];
  if (!title) {
    notify("请填写商品名称", false);
    return;
  }
  if (!catCode) {
    notify("请选择类目", false);
    return;
  }
  if (!chartId) {
    notify("请选择尺码表", false);
    return;
  }
  if (!file) {
    notify("请上传代表图", false);
    return;
  }
  let b64 = "";
  try {
    b64 = await readFileAsBase64(file);
  } catch (_) {
    notify("代表图读取失败", false);
    return;
  }
  const { ok, data } = await api("POST", "/api/v1/drama/garments/local", {
    body: {
      title,
      size_chart_id: chartId,
      cat_code: catCode,
      representative_image: b64,
      color: "默认色",
    },
  });
  if (!ok) {
    notify((data && data.message) || "登记失败", false);
    return;
  }
  notify(`已登记：${(data && data.title) || title}`, true);
  if ($("mall-catalog-title")) $("mall-catalog-title").value = "";
  if (picInput) picInput.value = "";
  const preview = $("mall-catalog-pic-preview");
  if (preview) {
    preview.innerHTML = "";
    preview.classList.add("hidden");
  }
  await loadMallCatalog();
}

export function initMallCatalogHandlers() {
  const catSel = $("mall-catalog-cat");
  if (catSel) {
    catSel.addEventListener("change", () => loadSizeChartOptions().then(() => {
      const box = $("mall-catalog-list");
      if (!box) return;
      box.querySelectorAll(".mc-catalog-row-chart").forEach((sel) => {
        const cur = sel.value || "";
        sel.innerHTML = chartOptionHtml(cur);
        if (cur) sel.value = cur;
      });
    }));
  }
  const picInput = $("mall-catalog-pic");
  if (picInput) {
    picInput.addEventListener("change", () => {
      const preview = $("mall-catalog-pic-preview");
      if (!preview) return;
      preview.innerHTML = "";
      const file = picInput.files && picInput.files[0];
      if (!file) {
        preview.classList.add("hidden");
        return;
      }
      preview.classList.remove("hidden");
      const img = document.createElement("img");
      img.src = URL.createObjectURL(file);
      img.alt = "代表图预览";
      img.width = 120;
      img.height = 120;
      preview.appendChild(img);
    });
  }
  bindClick("btn-mall-catalog-register", () => registerCatalogProduct());
  bindClick("btn-mall-catalog-refresh", () => loadMallCatalog());
}
